import classnames from 'classnames/bind'
import Link from 'next/link'
import { useTranslation } from 'next-i18next'

// Methods
import { helpSearchPath } from '../../methods'

// Styles
import styles from '../../style.module.scss'

const cx = classnames.bind(styles)

/** 搜尋框下方的熱門關鍵字；關鍵字放在語系檔（逗號分隔），各站可以各自調整 */
const PopularKeywords = ({ countryQuery }: { countryQuery?: string }) => {
  const { t } = useTranslation()
  const keywords = t('Help_Center_Popular_Keywords')
    .split(',')
    .map((k) => k.trim())
    .filter(Boolean)

  if (keywords.length === 0) return null

  return (
    <div className={cx('help-popular')}>
      <span className={cx('help-popular__label')}>{t('Help_Center_Popular')}</span>
      {keywords.map((keyword) => (
        <Link key={keyword} className={cx('help-popular__chip')} href={helpSearchPath(keyword, countryQuery)}>
          {keyword}
        </Link>
      ))}
    </div>
  )
}

export default PopularKeywords
